import $ from 'jquery';
import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import tabs from './algolia/tabsWidget.js';
import aa from 'search-insights';
import {
  configure,
  hits,
  pagination,
  searchBox,
  refinementList,
  sortBy
} from 'instantsearch.js/es/widgets';
import { COOP_NAME } from './config/index.js';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
import {
  scrollToElement,
  getQueryParamsAsObject,
  decodeHtml
} from './lib/utilities';

const formContainer = '#algolia-search-box';
const hitsContainer = '#algolia-hits';
const tabsContainer = '#algolia-tabs';
const sortbyContainer = '#algolia-sortby';
const paginationContainer = '#algolia-pagination';
const queryParams = getQueryParamsAsObject();
const appId = wlAlgolia.application_id;
const apiKey = wlAlgolia.search_api_key;
const indexName = wlAlgolia.indices.searchable_posts.name;
const localCoopValues = COOP_NAME ? [COOP_NAME, 'No Coop'] : ['No Coop'];
const insightsMiddleware = createInsightsMiddleware({
  insightsClient: aa
});

if ((queryParams || {}).s) setTimeout(scrollToTabs, 500);

if ($(formContainer).length > 0) {
  // Instantiate instantsearch.js
  const search = instantsearch({
    searchClient: algoliasearch(appId, apiKey),
    indexName,
    routing: {
      stateMapping: {
        stateToRoute: (uiState) => ({
          s: uiState[indexName].query,
          page: uiState[indexName].page
        }),
        routeToState: (routeState) => ({
          [indexName]: {
            query: routeState.s,
            page: routeState.page
          }
        })
      }
    }
  });
  search.use(insightsMiddleware);
  const widgetRefinementList = refinementList({
    container: '#algolia-refinement-list',
    attribute: 'local_coops',
    operator: 'or',
    cssClasses: {
      root: 'algolia-refinement-list'
    }
  });
  const widgetConfig = configure({
    hitsPerPage: 10,
    facetingAfterDistinct: true,
    disjunctiveFacetsRefinements: {
      local_coops: localCoopValues
    },
    highlightPreTag: '__ais-highlight__',
    highlightPostTag: '__/ais-highlight__',
    disjunctiveFacets: ['post_type_label', 'local_coops']
  });
  const widgetSearchBox = searchBox({
    container: formContainer,
    placeholder: 'Search by Keyword...',
    queryHook: (query, search) => search(query),
    poweredBy: false,
    reset: false,
    searchOnEnterKeyPressOnly: false,
    wrapInput: true,
    cssClasses: {
      submit: ['btn']
    },
    templates: {
      submit: `Search`
    }
  });
  const widgetHits = hits({
    escapeHTML: false,
    container: hitsContainer,
    templates: {
      empty: 'No results were found for "<strong>{{query}}</strong>".',
      item: window.wp.template('instantsearch-hit')
    },
    transformItems: (items) => {
      return items.map((item) => {
        function replace_highlights_recursive(hit) {
          if (hit instanceof Object && hit.hasOwnProperty('value')) {
            // hit.value = _.escape(hit.value);
            hit.value = hit.value
              .replace(/__ais-highlight__/g, '<em>')
              .replace(/__\/ais-highlight__/g, '</em>');
          } else {
            for (var key in hit) {
              hit[key] = replace_highlights_recursive(hit[key]);
            }
          }
          return hit;
        }
        item._highlightResult = replace_highlights_recursive(
          item._highlightResult
        );
        item._snippetResult = replace_highlights_recursive(item._snippetResult);
        item._highlightedTitle = decodeHtml(
          item._snippetResult.post_title.value
        );
        item._highlightedKicker = decodeHtml(item.kicker);
        item._highlightedDescription = '';
        if (
          item._highlightResult.hasOwnProperty('post_excerpt') &&
          item._highlightResult['post_excerpt'].value
        ) {
          item._highlightedDescription =
            item._highlightResult['post_excerpt'].value;
        } else if (
          item._snippetResult['content'].value !== '' &&
          item._snippetResult.hasOwnProperty('content')
        ) {
          item._highlightedDescription = item._snippetResult['content'].value;
        }

        return item;
      });
    }
  });
  const widgetPagination = pagination({
    container: paginationContainer,
    templates: {
      next: 'Next<i class="icon-arrow-right-blue"></i>',
      previous: '<i class="icon-arrow2-left-blue"></i>Prev'
    },
    maxPages: 8,
    showFirst: false,
    showLast: false,
    scrollTo: false,
    cssClasses: {
      noRefinementRoot: 'u--display-none'
    }
  });
  const widgetSortBy = sortBy({
    container: sortbyContainer,
    items: [
      { label: 'Relevance', value: indexName },
      { label: 'Newest', value: indexName + '_replica_newest' },
      { label: 'Oldest', value: indexName + '_replica_oldest' }
    ]
  });
  const widgetTabs = tabs({
    container: tabsContainer,
    facet: 'post_type_label',
    tabs: [
      {
        title: 'All',
        posts: [
          'Articles',
          'Recipes',
          'Magazines',
          'Pages',
          'Products',
          'Events'
        ]
      },
      {
        title: 'Articles',
        posts: ['Articles']
      },
      {
        title: 'Recipes',
        posts: ['Recipes']
      }
    ]
  });
  let userToken = '';

  search.addWidgets([
    widgetRefinementList,
    widgetConfig,
    widgetSearchBox,
    widgetSortBy,
    widgetHits,
    widgetPagination,
    widgetTabs
  ]);

  // Start search
  search.start();

  // Get search queryID, needed for analytics payload.
  const getQueryID = () => search.helper.lastResults.queryID;

  // Focus input
  $(formContainer).find('input').attr('type', 'search').select();

  // Init Algolia analytics
  aa('init', { appId, apiKey });
  aa('getUserToken', null, (err, algoliaUserToken) => {
    if (err) return;
    userToken = algoliaUserToken;
  });

  // Add event listeners to scroll to search content
  $('html').on('submit', formContainer, scrollToTabs);
  $('html').on('click', `${paginationContainer} a`, scrollToTabs);
  $('html').on('click', `${tabsContainer} button`, scrollToTabs);
  $('html').on('click', `${hitsContainer} a.search-hit`, (event) => {
    aa('clickedObjectIDsAfterSearch', {
      userToken,
      eventName: 'Hit Clicked',
      index: indexName,
      objectIDs: [event.currentTarget.getAttribute('data-object-id')],
      positions: [
        parseInt(event.currentTarget.getAttribute('data-object-position'))
      ],
      queryID: getQueryID()
    });
  });
}

function scrollToTabs(event) {
  if (event) event.preventDefault();
  scrollToElement(tabsContainer);
}
